import styled from "styled-components";
import {Color, Colors } from "./Colors"
import { Link } from "react-router";

/* Create table with grid - info- and action documents (Agenda Generator) */ 
export const DocsWrapper = styled.div`
    display: flex; 
    flex-direction: column; 
    justify-content: space-between; 
    width: 100%; 
        
    & > div {
        display: grid; 
        grid-template-columns: ${({$type}) => (
            $type === 'information_docs'
                ? '4fr 1fr 3rem'
                : '2fr 1fr 1fr 3rem'
        )}; 
        gap: 1.5rem; 
        align-items: start; 
        border-bottom: 3px double ${Color(Colors.black)}; 
    }

    & > div:first-of-type > span { 
        font-weight: 600; 
    }
        
    & > div > span {
        justify-content: center; 
        align-items: center;  
        min-height: 50px;  
        color: ${Color(Colors.black)}; 
        flex-wrap: wrap;
        line-height: 1.5; 
        width: 100%; 
        white-space: pre-wrap;
        overflow-wrap: anywhere; 
        word-break: break-word; 
    }

    & > div:first-of-type > span:first-of-type,
    & > div:not(:first-of-type) > span:first-of-type {
        padding-left: .5rem;
    }

    & > div:first-of-type > span:last-of-type, 
    & > div:not(:first-of-type) > span:last-of-type {
        padding-right: .5rem;
    } 

    & > div:not(:first-of-type) > span {
        padding: 1rem 0 1rem 0;
    }

    & > div > span:last-of-type {
        display: flex; 
        justify-content: flex-end; 
        align-items: flex-start; 
    }

    @media screen and (max-width: 1100px) {
        & > div {
            grid-template-columns: ${({$type}) => (
                $type === 'information_docs'
                    ? '2fr 1fr 3rem'
                    : '1fr 1fr 1fr 2rem'
            )}; 
        }
    }
`;
/* Styled span - used for info- and action documents (agenda generator) */ 
export const TableColumn = styled.span` 
    min-width: 0; 

    & > p {
        white-space: pre-wrap;
        overflow-wrap: anywhere; 
        word-break: break-word; 
    }

    & > p:first-of-type {
        padding: 0 0 4px 0; 
    }

    & > p:last-of-type {
        padding: 4px 0 0 0;  
    }

    & > div {
        & > a {
            display: block; 
        }
    }
`;

/* Create table for upcoming meetings (Agenda Generator) */
export const MeetingsWrapper = styled.div`
    display: grid; 
    grid-template-columns: 1fr 1fr 5rem; 
    border-bottom: 3px double ${Color(Colors.black)};  
    
    &:first-of-type {
        border-top: 3px double ${Color(Colors.black)}; 
    }

    .cell {
        padding: 1rem 0.5rem 1rem 0.5rem; 
        width: 100%; 
        white-space: pre-wrap;
        overflow-wrap: anywhere; 
        word-break: break-word; 
    }

    .cell-header {
        border-bottom: 2px solid ${Color(Colors.black)}; 
        font-weight: 600; 
    }
        
    .cell-left {
        border-right: 2px dashed ${Color(Colors.black)}; 
    }

    .cell-last-item {
        justify-self: end; /* Horizontal */
        align-self: start;  /* Vertical */ 
    } 
`;

/* Layout grid for all pages - sidebar on the left and the main content on the right */
export const Container = styled.div`
    display: grid;
    grid-template-columns: 1fr 5fr; 
    position: relative; 
    height: 100%; 

    @media (max-width: 1150px) {
        grid-template-columns: 5rem 5fr; 
    }
`;

/* Content grid - ensure the main-content scales down smoothly with the screen size  */
export const Wrapper = styled.div`
    display: grid;
    grid-template-columns: minmax(16px, 1fr) [inner-start] minmax(0, 60rem) [inner-end] minmax(16px, 1fr);
    
    & > div {
        grid-column: inner; 

        & > h1 {
            padding: 1rem 0 0 0; 
        }
    }

`;

/* Style for the Tools Overview */
export const Tools = styled.div`
    padding: 2rem 0 2rem 0;     

    h4 {
        padding: 0 0 1rem 0; 
    }

    & > div {
        display: flex; 
        flex-wrap: wrap; 
        gap: 1rem; 
    }
`;

/* Style for the individual tool inside of the tools overview*/
export const Tool = styled(Link)`
    display: flex; 
    flex-direction: column; 
    justify-content: center; 
    align-items: flex-start; 
    background-color: ${Color(Colors.blue)}; 
    max-width: 300px; 
    width: 100%; 
    height: 148px; 
    padding: 1rem; 
    border-radius: 4px; 
    text-decoration: none; 

    & > div {
        display: flex; 
        justify-content: center; 
        align-items: center;
        padding: 0 0 .5rem 0; 
        
        & > svg {
            transform: scale(1.15);
            transform-origin: 50% 50%;
            height: 28px;
            width: 28px; 
            fill: ${Color(Colors.white)}; 
            margin: 0 0.5rem 0 0; 
            border-radius: 2px; 

            & > g > path {
                fill: ${Color(Colors.white)}; 
            }
        } 
    }

    span {
        color: ${Color(Colors.white)}; 
    }

    &:hover {
        background-color: ${Color(Colors.lightBlue)}; 
    }
        
    p {
        color: ${Color(Colors.white)}; 
        font-size: 14px; 
    }

    @media (max-width: 1050px) {
        margin: 1rem 0 0 0;  
        max-width: none; 
    }
`;
